import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';


class SentContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            trigger: false,
            contactFormSent: false,
        };

        this.triggetNext = this.triggetNext.bind(this);
    }

    componentWillMount() {
        const {steps,store} = this.props;
        const bodyFormData = new FormData();


        if(store.patient.national_id){
            bodyFormData.append('national_id', store.patient.national_id);
        }else{
            bodyFormData.append('patient_name', steps.patient_name.value);
            bodyFormData.append('patient_email', steps.patient_email.value);
            bodyFormData.append('patient_phone', steps.patient_phone.value);
        }



        bodyFormData.append('patient_message', steps.patient_message.value);

        API.post(
            '/sendContactForm',
            bodyFormData,
            {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {
            const result = res.data;
            if (result.status == "success") {
                this.setState({contactFormSent: true, loading: false})
            } else {
                this.setState({contactFormSent: false, loading: false})
            }

            this.triggetNext(true);
        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    render() {
        const {loading, contactFormSent} = this.state;
        const {step} = this.props;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    contactFormSent ? (
                        <span>{step.metadata.successMsg}</span>
                    ) : (
                        <span>{step.metadata.errorMsg}</span>
                    )
                )}
            </div>
        );
    }


}

SentContactForm.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

SentContactForm.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default SentContactForm;
